export class ReadMode {
  constructor(
    public name?: string,
    public code?: string,
  ) { }

  clone() {
    return new ReadMode(
      this.name,
      this.code
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/read-mode.ts